// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 7559) return "static/chunks/7559-36556a3ce601b7cc.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "e7393e7739e67c8f" + ".js";
};